<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_7"></a>
<p class="part">PART ONE</p>
<p class="line"><img alt="images" height="7" src="images/line.jpg" width="84"/></p>
<p class="parttitle">Scotsman</p>
<p class="pagebreak">
<a id="page_8"></a>
</p><p class="image"><a id="img1"></a><img alt="images" height="580" src="images/f0001-01.jpg" width="358"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Part01.vue?5b5c5e13